var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1011 8.7707L22.0672 10.3603M14.8222 13.5167L17.8053 14.3115M14.9706 22.458L16.1638 22.776C19.5388 23.6752 21.2263 24.1248 22.5557 23.3616C23.8851 22.5984 24.3372 20.9204 25.2415 17.5645L26.5204 12.8185C27.4247 9.46257 27.8769 7.7846 27.1094 6.4627C26.3418 5.1408 24.6544 4.69119 21.2794 3.79197L20.0862 3.47405C16.7112 2.57483 15.0237 2.12522 13.6943 2.88842C12.3649 3.65162 11.9128 5.32959 11.0085 8.68551L9.72957 13.4315C8.82526 16.7874 8.3731 18.4654 9.14063 19.7873C9.90816 21.1092 11.5956 21.5588 14.9706 22.458Z",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.1829L13.8096 26.507C10.4425 27.4239 8.75902 27.8823 7.43274 27.1042C6.10646 26.326 5.65536 24.6151 4.75317 21.1933L3.47727 16.3543C2.57508 12.9325 2.12398 11.2216 2.88971 9.8738C3.55208 8.70789 5 8.75034 6.875 8.75019",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.0c3d85485b54cdae8d4f0b36e22a2730.svg";
export { ForwardRef as ReactComponent };